import React from 'react'

export default class DashboardSeverity extends React.Component {
  render () {
    var edadArterial
    var edadBiologica

    if (this.props.data.arterialAge.toFixed(1) >= 85) {
      edadArterial = '> 85'
    } else {
      edadArterial = this.props.data.arterialAge.toFixed(1)
    }

    if (this.props.data.biologicalAge.toFixed(1) >= 85) {
      edadBiologica = '> 85'
    } else {
      edadBiologica = this.props.data.biologicalAge.toFixed(1)
    }

    return (
      <div className='severity-section'>
        <div className='severity-components'>
          <div className='result-data-values'>
            <span className='severity-data'>Edad Arterial</span>
            <span className='severity-value'>{ edadArterial + ' años'}</span>
          </div>
          <div className='result-data-values'>
            <span className='severity-data'>Edad Biológica</span>
            <span className='severity-value'>{ edadBiologica + ' años'}</span>
          </div>
          <div className='result-data-values-rcv'>
            <span className='severity-data'>RCV Total</span>
            <span>&nbsp;</span>
          </div>
        </div>
      </div>
    )
  }
}

/* Validate Props */
DashboardSeverity.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardSeveritySection.js